<template>
  <b-col sm="12" lg="6">
    <div class="feature-heading">
      <div class="copy-container">
        <div class="copy">
          <h2>{{title}}</h2>
          <p>
            <slot>Content goes here!</slot>
          </p>
        </div>
      </div>
    </div>
    <div class="parent">
      <ul class="list-1">
        <li class="item-container-1" v-for="{title, description} in items">
          <div class="icon">
            <img src="/static/images/homepage/quality.svg" alt="icon" />
          </div>
          <div class="list-copy-container-1">
            <p class="title">{{title}}</p>
            <p class="description">{{description}}</p>
          </div>
        </li>
      </ul>
    </div>
  </b-col>
</template>
<script>
export default {
  props: ["title", "items"]
};
</script>

<style lang="scss" scoped>
@import "~scss/colors";

.parent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 1em;
  margin: 0 1em 1em 1em;
  @media (max-width: 992px) {
    width:500px;
    padding:1em 0;
    margin: 0 auto;
  }
  @media (max-width: 576px) {
    width:100%;
    padding: 1em 0;
    margin: 0 auto;
  }
}

.feature-heading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1em 1em 0 1.2em;
  margin: 1em 1em 0 1em;
  @media (max-width: 992px) {
    width:500px;
    padding:1em 0 0 0;
    margin: 0 auto;
  }
  @media (max-width: 576px) {
    width:100%;
    padding: 1em 0;
    margin: 0 auto;
  }
}

@media (max-width: 576px) {
  .copy h2 {
    font-size: larger;
    margin-bottom: 0.5em;
  }
}

/* list-1 */

.list-1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 2;
  border-radius: 8px;
}

.list-1 {
  background-color: $white;
}

.item-container-1 {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: solid 3px $frost-0;
  @media (max-width: 576px) {
    padding: 10px;
  }
}

.item-container-1:last-child {
  border: none;
}

.icon {
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -8px 0 0 0;
  @media (max-width: 992px) {
    margin: -2px 0 0 0;
  }
  @media (max-width: 576px) {
    margin: 5px 0 0 0;
  }
}

.list-copy-container-1 {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: $black-1;
  margin-bottom: 10px;
  @media (max-width: 576px) {
    margin: 5px 0;
  }
}

.description {
  font-size: 14px;
  line-height: 1.5;
  color: $black-1;
  margin-bottom: 0;
}

p {
  font-size: medium;
  color: $black-1;
  line-height: 1.2;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/homepage/shared/FeatureSection.vue